import Header from "Dashboard/components/Header";
import MainSection from "./components/MainSection";
import Toolbox from "./components/Toolbox";
import "./styles/main.scss";
import { useCallback, useEffect, useState } from "react";
import { IExemptionSearch } from "../../domain/IExemptionSearch";
import { getExemptions } from "./output.slice";
import { useAppDispatch } from "hooks/hooks";
import usePagingAndSort,
{
  IGetPageRequestParams,
  IUpdateStateAfterSearchParams
} from "hooks/pagingAndSort";
import { useForm } from "react-hook-form";

const Index = () => {
  const dispatch = useAppDispatch();

  const defaultGetOutputListItemsSearchParams: IExemptionSearch = { searchTerm: undefined };

  const [getOutputListItemsSearchParams, setGetOutputListItemsSearchParams]
    = useState<IExemptionSearch>(
      defaultGetOutputListItemsSearchParams);

  const limit = 200;

  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    reset: resetSearch,
    control: controlSearch,
    getValues: getValuesSearch,
    setFocus: setFocusSearch,
    setValue: setValueSearch
  } = useForm<IExemptionSearch>({
    defaultValues: defaultGetOutputListItemsSearchParams
  });

  const getStockInputsWithPaging = useCallback((
    pagingParams: IGetPageRequestParams,
    abortSignal: AbortSignal,
    updateStateAfterFetch: (updateStateParams: IUpdateStateAfterSearchParams) => void
  ): void => {
    dispatch(getExemptions({
      getOutputListItemsSearchParams,
      pagingParams,
      abortSignal,
      updateStateAfterFetch
    }));
  }, [dispatch, getOutputListItemsSearchParams]);

  const { doSortBy, resetAfterSearch, lastElementRef, handleScroll } =
    usePagingAndSort(
      getStockInputsWithPaging,
      limit,
    );

  useEffect(() => {
    resetAfterSearch();
  }, [getOutputListItemsSearchParams]);

  return (
    <>
      <Header title="Potrošni materijali - IZLAZ" />
      <Toolbox
        setGetOutputListItemsSearchParams={setGetOutputListItemsSearchParams}
        defaultGetOutputListItemsSearchParams={defaultGetOutputListItemsSearchParams}
        registerSearch={registerSearch}
        handleSubmitSearch={handleSubmitSearch}
        resetSearch={resetSearch}
        controlSearch={controlSearch}
        getValuesSearch={getValuesSearch}
        setFocusSearch={setFocusSearch}
        setValueSearch={setValueSearch}
      />
      <MainSection
        lastTableElementRef={lastElementRef}
        handleScroll={handleScroll}
      />
    </>
  );
};
export default Index;
